<template>
  <section class="fifth-frame w-100 bg-grey">
    <!-- differentials -->
    <differentials/>
    
    <!-- content -->
    <b-container class="pb-5">
      <b-row class="mb-5">
        <b-col
          cols="12"
          class="text-purple text-left pt-5"
        >
          
        </b-col>
      </b-row>

      <b-row class="align-items-center">
        <b-col
          md="6" 
          class="text-purple font-weight-light pb-5 text-left text-md-left text-lg-left text-xl-left"
        >
          <h1 class="font-weight-normal">O <strong>futuro chegou</strong> com a <strong>VAAPTY</strong></h1>
          <hr>
          <p>Inovando mais uma vez a <strong>VAAPTY</strong> lança no mercado um <strong>novo conceito de profissionais</strong> em vendas de veículos, criando uma nova modalidade de trabalho com os <strong>auto traders</strong> que atenderão com <strong>mais comodidade</strong> as pessoas que querem <strong>vender seu carro em sua própria casa ou trabalho.</strong></p>

          
        </b-col>

        <b-col
          md="6" 
          class="bg-quem-somos mb-5 d-none d-md-inline-block d-lg-inline-block d-xl-inline-block"
        />
      </b-row>
    </b-container>

  </section>
</template>

<script>
// all
import Differentials from '@/components/Differentials'

export default {
  components: {
    'differentials': Differentials
  }
}
</script>


<style lang="scss" scoped>
  section {
    min-height: 90vh;
  }

  .bg-quem-somos {
    background: url('./../../assets/images/about/quemsomos-1.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 260px;
  }
</style>
